import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';

import AppRoutes from './components/Routes/AppRoutes';
import LogIn from './pages/Auth/login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Invitation from './pages/Invitation/Invitation';
import { isAuthenticated } from './utilities/authentication';


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public invitation route (accessible without auth) */}
          <Route path='/invite/:token' element={<Invitation />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          
          {isAuthenticated() ? (
            <>
              <Route path='/*' element={<AppRoutes />} />
            </>
          )
            :
            <>
              <Route path='/' element={<LogIn />} />
              <Route path='/login' element={<LogIn />} />
              <Route path='*' element={<LogIn />} />
            </>
          }
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
